/**
 * Checks if a given country code is within the European Union.
 *
 * @param {string} countryCode - The two-letter country code (ISO 3166-1 alpha-2).
 * @returns {boolean} - Returns true if the country is in the EU, false otherwise.
 */
export function isEU(countryCode) {
  const euCountries = [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK",
  ];

  if (typeof countryCode !== "string" || countryCode.length !== 2) {
    return false; // Invalid input
  }

  return euCountries.includes(countryCode.toUpperCase()); // Case-insensitive check
}
